import { render, staticRenderFns } from "./ClaimUpdateEvent.vue?vue&type=template&id=dea4fd04&scoped=true&"
import script from "./ClaimUpdateEvent.vue?vue&type=script&lang=js&"
export * from "./ClaimUpdateEvent.vue?vue&type=script&lang=js&"
import style0 from "./ClaimUpdateEvent.vue?vue&type=style&index=0&id=dea4fd04&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea4fd04",
  null
  
)

export default component.exports